import { type Modification } from '../../types';
import { checkIfBaseIngredient } from './check-if-base-ingredient';

export function checkIfGreenBaseIngredient(modification: Modification) {
  const isBaseIngredient = checkIfBaseIngredient(modification);
  const isNotGrain = !modification.ingredient?.isGrain;

  return isBaseIngredient && isNotGrain;
}
